var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "brdr-none bg-cl-transparent p0 middle-xs inline-flex cl-secondary weight-400 h4 sans-serif fs-medium"
    },
    [
      _c("span", { staticClass: "clearcart-btn cl-mine-shaft" }, [
        _c("i", { staticClass: "material-icons cl-mine-shaft mr5" }, [
          _vm._v("\n      cancel\n    ")
        ]),
        _vm._v("\n    " + _vm._s(_vm.$t("Clear cart")) + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }